import * as React from "react";
import { ModelState } from "../../Models/ModelStateEnum";
import RbhRequestUnserviceableCreate from "./RbhRequestUnserviceableCreate";
import RbhRequestUnserviceableUpdate from "./RbhRequestUnserviceableUpdate";
import { UnserviceableStatu } from "../../../../Enums/UnserviceableStatus";

const RbhRequestUnserviceable = props => {
  const [tabType, setTabType] = React.useState(ModelState.Create);
  React.useEffect(() => {
    var tempTabType =
      props?.requestUnserviceableData === null
        ? ModelState.Create
        : [UnserviceableStatu.Accepted, UnserviceableStatu.Rejected].includes(props?.requestUnserviceableData?.status)
          ? ModelState.View
          : ModelState.Edit;
    setTabType(tempTabType);
  }, [props?.requestUnserviceableData]);
  switch (tabType) {
    case ModelState.Create:
      return (
        <RbhRequestUnserviceableCreate
          resource="/requestunserviceables"
          basePath=""
          requestId={props.requestId}
          requestDetail={props.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
        />
      );
    default:
      return (
        <RbhRequestUnserviceableUpdate
          requestDetail={props.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
          requestId={props.requestId}
        />
      );
  }
};

export default RbhRequestUnserviceable;
